import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../Context';
import { useEffect } from 'react';

function PrivateRoute({ component: Component, ...rest }) {
    
    const { isLoggedIn } = useAuth();

    useEffect(() => {
		console.log('isLoggedIn = ', isLoggedIn)
	}, [isLoggedIn])
  
    return (
        <Route
            {...rest}
            render={(props) =>
                isLoggedIn ? <Component {...props} /> : <Redirect to="/admin/login" />
            }
        />
    );
}
export default PrivateRoute;